// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-dropdown {
    position: relative;
    /* width: 200px; */
  }
  
  .dropdown-header {
    border: 1px solid #ccc;
    cursor: pointer;
    box-sizing: border-box;
  }
  
  .dropdown-header.open {
    border-bottom: 1px solid #ccc; /* Highlight the header when the dropdown is open */
  }
  
  .dropdown-options {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    border: 1px solid #ccc;
    background-color: white;
    z-index: 1000;
    box-shadow: 1px 4px 15px 0px lightgray;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    display: flex;
    /* gap: 13px; */
    flex-direction: column;
    overflow-y: scroll;
  }
  
  .dropdown-option {
    cursor: pointer;
    padding: 7px 20px 7px 20px;
    color: black;
    font-size: 14px;
    font-weight: 400;
  }
  
  .dropdown-option:hover {
    background-color: #f2f2f2; /* Highlight the option on hover */
  }
  `, "",{"version":3,"sources":["webpack://./src/components/ui/dropdown/dropdown.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,6BAA6B,EAAE,mDAAmD;EACpF;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,sCAAsC;IACtC,+BAA+B;IAC/B,gCAAgC;IAChC,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,0BAA0B;IAC1B,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB,EAAE,kCAAkC;EAC/D","sourcesContent":[".custom-dropdown {\n    position: relative;\n    /* width: 200px; */\n  }\n  \n  .dropdown-header {\n    border: 1px solid #ccc;\n    cursor: pointer;\n    box-sizing: border-box;\n  }\n  \n  .dropdown-header.open {\n    border-bottom: 1px solid #ccc; /* Highlight the header when the dropdown is open */\n  }\n  \n  .dropdown-options {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    border: 1px solid #ccc;\n    background-color: white;\n    z-index: 1000;\n    box-shadow: 1px 4px 15px 0px lightgray;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n    display: flex;\n    /* gap: 13px; */\n    flex-direction: column;\n    overflow-y: scroll;\n  }\n  \n  .dropdown-option {\n    cursor: pointer;\n    padding: 7px 20px 7px 20px;\n    color: black;\n    font-size: 14px;\n    font-weight: 400;\n  }\n  \n  .dropdown-option:hover {\n    background-color: #f2f2f2; /* Highlight the option on hover */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
